import React, { useEffect, useMemo, useRef, useState } from "react";

// Custom organization dropdown that matches the dark dashboard UI (a native
// <select>'s option list can't be themed). Searchable, since there are many orgs.
export default function OrgFilter({ organizations, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    function onKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const selectedLabel = value
    ? organizations.find((o) => String(o.id) === String(value))?.name || "Organization"
    : "All organizations";

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? organizations.filter((o) => (o.name || "").toLowerCase().includes(q)) : organizations;
  }, [organizations, query]);

  function pick(v) {
    onChange(v);
    setOpen(false);
    setQuery("");
  }

  return (
    <div className="es-orgdd" ref={ref}>
      <button
        type="button"
        className={"es-orgdd__trigger" + (open ? " is-open" : "")}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <i className="ph ph-buildings es-orgdd__icon"></i>
        <span className="es-orgdd__label">{selectedLabel}</span>
        <i className="ph ph-caret-down es-orgdd__caret"></i>
      </button>

      {open && (
        <div className="es-orgdd__panel" role="listbox">
          <div className="es-orgdd__searchwrap">
            <i className="ph ph-magnifying-glass"></i>
            <input
              className="es-orgdd__search"
              placeholder="Search organizations…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              autoFocus
            />
          </div>
          <div className="es-orgdd__list">
            <button
              type="button"
              className={"es-orgdd__opt" + (!value ? " is-active" : "")}
              onClick={() => pick("")}
            >
              All organizations
            </button>
            {filtered.map((o) => (
              <button
                key={o.id}
                type="button"
                className={"es-orgdd__opt" + (String(o.id) === String(value) ? " is-active" : "")}
                onClick={() => pick(String(o.id))}
              >
                {o.name}
              </button>
            ))}
            {filtered.length === 0 && <div className="es-orgdd__empty">No matches</div>}
          </div>
        </div>
      )}
    </div>
  );
}
